import React, { FC } from 'react';
import { T } from '@sm/intl';
import useStyles from './useStyles';

// TODO: Wrap in defineMessages when ready for translations
const DEFAULT_COPY = {
  PRIVACY: {
    id: 'GooglePrivacyPolicy.Privacy',
    defaultMessage: 'Google Privacy Policy',
    description: '[Type: Link][Vis: med] - Google Privacy Policy anchor element',
  },
};

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface GooglePrivacyPolicyProps {
  /** URL for the google privacy policy anchor element */
  googlePrivacyPolicyURL: string;
}
const GooglePrivacyPolicy: FC<GooglePrivacyPolicyProps> = ({ googlePrivacyPolicyURL }) => {
  const { anchorElement } = useStyles();
  return (
    <a href={googlePrivacyPolicyURL} className={anchorElement}>
      <T desc={DEFAULT_COPY.PRIVACY} />
    </a>
  );
};

export default GooglePrivacyPolicy;
